import React from 'react';
import Slider from 'react-slick';
import { Card, CardContent } from './ui/card';

const MobileSlider = ({ items, type = 'default' }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    arrows: false,
  };

  return (
    <div className="mobile-slider-container">
      <Slider {...settings}>
        {items.map((item, index) => {
          const Icon = item.icon;
          
          if (type === 'features') {
            return (
              <div key={index} className="px-2">
                <Card className="hover:shadow-lg transition-shadow duration-300">
                  <CardContent className="p-6 text-center">
                    {Icon && (
                      <div className="inline-block p-3 bg-[#E5B80B]/10 rounded-lg mb-4">
                        <Icon className="h-10 w-10 text-[#E5B80B]" />
                      </div>
                    )}
                    <h3 className="text-xl font-bold text-[#1E1E1E] mb-3">{item.title}</h3>
                    <p className="text-gray-600 leading-relaxed">{item.description}</p>
                  </CardContent>
                </Card>
              </div>
            );
          }
          
          if (type === 'steps') {
            return (
              <div key={index} className="px-2">
                <Card className="hover:shadow-lg transition-shadow duration-300">
                  <CardContent className="p-6 text-center">
                    <div className="w-16 h-16 rounded-full bg-[#E5B80B] text-[#1E1E1E] flex items-center justify-center text-2xl font-bold mb-4 mx-auto">
                      {index + 1}
                    </div>
                    <h3 className="text-xl font-bold text-[#1E1E1E] mb-3">{item.title}</h3>
                    <p className="text-gray-600 leading-relaxed">{item.description}</p>
                  </CardContent>
                </Card>
              </div>
            );
          }
          
          return (
            <div key={index} className="px-2">
              <Card>
                <CardContent className="p-6">
                  <p className="text-gray-600">{item.text || item.description}</p>
                </CardContent>
              </Card>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default MobileSlider;
